import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AdsProvider } from "@/lib/ads";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CompleteProfileModal from "@/components/CompleteProfileModal";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import ReceiptPage from "@/pages/ReceiptPage";
import Profile from "@/pages/Profile";
import Search from "@/pages/Search";
import Notifications from "@/pages/Notifications";
import Following from "@/pages/Following";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Challenge from "@/pages/Challenge";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import { HowItWorks, HowReceipts, ResolutionRules, Guidelines, Terms, Privacy } from "@/pages/StaticPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback BEFORE any route/auth logic (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <CompleteProfileModal />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/c/:shortId" element={<ReceiptPage />} />
          <Route path="/search" element={<Search />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/following" element={<Following />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/challenge/:id" element={<Challenge />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/how-receipts-work" element={<HowReceipts />} />
          <Route path="/resolution-rules" element={<ResolutionRules />} />
          <Route path="/guidelines" element={<Guidelines />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/:username" element={<Profile />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AdsProvider>
            <AppRouter />
            <Toaster position="top-center" />
          </AdsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
